import { __awaiter, __generator } from 'tslib';

function delay(fn, ms) {
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(fn()); }, ms); });
}
var totalDuration = 30000;
function setDefaultMaxDuration(maxDuration) {
    totalDuration = maxDuration;
}
function calculateSafeRetryMs(maxRetries, retryMs) {
    var maxRetriesSquared = Math.pow(maxRetries, 2);
    var maxMs = retryMs * maxRetriesSquared;
    if (maxMs >= totalDuration) {
        return totalDuration / maxRetriesSquared;
    }
    return retryMs;
}
var defaultMaxRetries = 5;
/**
 * @param callback A function that returns a promise
 * @param maxRetries Maximum number of retries. Defaults to 5
 * @param retryMs Milliseconds factor to wait before retrying. Defaults to 100
 * @returns The result of the callback
 */
function backoff(callback, maxRetries, retryMs) {
    if (maxRetries === void 0) { maxRetries = defaultMaxRetries; }
    if (retryMs === void 0) { retryMs = 100; }
    return __awaiter(this, void 0, void 0, function () {
        function execute(retryCount) {
            return __awaiter(this, void 0, void 0, function () {
                var result, error_1, newRetryCount_1, definitiveRetryMs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, callback()];
                        case 1:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 2:
                            error_1 = _a.sent();
                            if (retryCount <= maxRetries) {
                                newRetryCount_1 = retryCount + 1;
                                definitiveRetryMs = calculateSafeRetryMs(maxRetries, retryMs);
                                return [2 /*return*/, delay(function () { return execute(newRetryCount_1); }, definitiveRetryMs * newRetryCount_1 * maxRetries)];
                            }
                            else {
                                throw error_1;
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        return __generator(this, function (_a) {
            return [2 /*return*/, execute(1)];
        });
    });
}

export { backoff, setDefaultMaxDuration };
//# sourceMappingURL=index.esm.js.map
